import { ImpositionCalculatorModal } from './ImpositionCalculatorModal';
import React from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Plus, Trash2, LayoutGrid } from "lucide-react";
import PrepressSection from "./PrepressSection";
import RoutingSection from "./RoutingSection";

interface EstimatingComponentTabProps {
  componentIndex: number;
}

export default function EstimatingComponentTab({
  componentIndex,
}: EstimatingComponentTabProps) {
  const { control, setValue } = useFormContext();
  const [isImpositionModalOpen, setIsImpositionModalOpen] = React.useState(false);

  return (
    <div className="space-y-6 pt-4">
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={control}
          name={`components.${componentIndex}.name`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tên Component (VD: Ruột, Bìa)</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name={`components.${componentIndex}.outUp`}
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex justify-between items-center">
                <span>Số Out/Up (Số lượng SP/Tờ)</span>
                <Button 
                  type="button" 
                  variant="ghost" 
                  size="sm" 
                  className="h-6 px-2 text-xs text-indigo-600 hover:bg-indigo-50"
                  onClick={() => setIsImpositionModalOpen(true)}
                >
                  <LayoutGrid className="w-3 h-3 mr-1" /> Bình File
                </Button>
              </FormLabel>
              <FormControl>
                <Input
                  type="number"
                  {...field}
                  onChange={(e) =>
                    field.onChange(parseInt(e.target.value) || 1)
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <PrepressSection componentIndex={componentIndex} />
      <RoutingSection componentIndex={componentIndex} />
      <ImpositionCalculatorModal 
        isOpen={isImpositionModalOpen}
        onClose={() => setIsImpositionModalOpen(false)}
        onApply={(outs, w, l) => {
          setValue(`components.${componentIndex}.outUp`, outs);
          setValue(`components.${componentIndex}.sheetWidth`, w);
          setValue(`components.${componentIndex}.sheetLength`, l);
          setIsImpositionModalOpen(false);
        }}
      />
    </div>
  );
}
